import { render, staticRenderFns } from "./HistoryFinance.vue?vue&type=template&id=10a32a68&scoped=true"
import script from "./HistoryFinance.vue?vue&type=script&lang=js"
export * from "./HistoryFinance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a32a68",
  null
  
)

export default component.exports